import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {validateFields, validateField} from './../../../utilities/validation/validator';
import {getDefaultDate, formatDeliveryTimeSlots} from './../../../utilities/dateUtils';
import {regexPatterns} from './../../../utilities/validation/validationVariables';
import ProviderManager from '../../../provider/providerManager';
import lodash from 'lodash';

export const getDeliveryTimeSlots = createAsyncThunk('SetUpDeliveries/getDeliverySlots', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getDeliverySlots', [data.city, data.street, data.homeNum, data.products]);

    return result.Body;
  } catch (error) {
    return error;
  }
});

const setupDeliveriesSlice = createSlice({
  name: 'setupDeliveries',
  initialState: {
    form: {
      deliveryTimeSlots: [],
      isLeaveSimInBox: false,
      isNewAddress: false,
      deliveryTime: '',
      round: '',
      roundName: '',
      waitFrom: '',
      waitTo: '',
      lfdat: '',
      weekdayL: '',
      pickLocation: '',
      isLoading: true,
      selectedOption: '0',
      errorObj: '',
      errorId: 0,
      valid: '',
      errors: {},
      rules: {
        deliveryTime: {
          required: {value: true, error: 'לא נבחר מועד'},
        },
      },
    },
  },

  reducers: {
    deliveryValidateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return {payload: validate};
      },
    },
    clearTimeSlots: {
      reducer(state, action) {
        state.form.deliveryTime = '';
        state.timeSlots = [];
      },
    },
    clearValid: {
      reducer(state, action) {
        state.form.valid = '';
      },
    },
    initValidation: {
      reducer(state, action) {
        state.form.valid = '';
      },
    },
    setIsLeaveSimInBox: {
      reducer(state, action) {
        state.form.isLeaveSimInBox = action.payload.isLeaveSimInBox;
      },
    },
    setIsNewAddress: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload.form);
        form.isNewAddress = payload.value;
        return {payload: form};
      },
    },
    startLoading: {
      reducer(state, action) {
        const form = {...state.form}; // your state form obj
        form.isLoading = false;
        state['form'] = form;
      },
    }, 
    setSelectedOption: (state, action) => {
      state.form.selectedOption = action.payload;
    },    
    deliveryChangeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;

        const form = lodash.cloneDeep(payload.form);

        form.round = payload.target.round;
        form.roundName = payload.target.roundName;
        form.waitFrom = payload.target.waitFrom;
        form.waitTo = payload.target.waitTo;
        form.lfdat = payload.target.lfdat;
        form.weekdayL = payload.target.weekdayL;
        form.pickLocation = payload.target.pickLocation;

        const validate = validateField(form, name, value);

        return {payload: validate};
      },
    },
  },
  extraReducers: {
    [getDeliveryTimeSlots.fulfilled]: (state, action) => {
      if (action.payload.message !== '' && action.payload.message != undefined) {
        state.form.errorObj = {errorId: 19, message: action.payload.message};
        state.form.errorId = 19;
        return;
      }

      if (action.payload.errorCode != undefined && action.payload.errorCode == 1200) {
        state.form.errorObj = {errorId: 20, message: action.payload.returnCodeMessage};
        state.form.errorId = 20;
        return;
      }

      try {
        state.form.deliveryTimeSlots = formatDeliveryTimeSlots(action.payload);
      } catch (error) {
        state.form.errorObj = {errorId: 19, message: action.payload.message};
        state.form.errorId = 19;
      }

      state.form.isLoading = false;
    },
  },
});

export const {
  deliveryChangeHandler,
  deliveryValidateHandler,
  startLoading,
  setSelectedOption,
  setIsNewAddress,
  clearTimeSlots,
  setIsLeaveSimInBox,
  initValidation,
  clearValid,
} = setupDeliveriesSlice.actions;
export default setupDeliveriesSlice.reducer;
